import { Image } from '@chakra-ui/core';
import React from 'react';
import BidenFaceImage from '../assets/biden_face.svg';
import TrumpFaceImage from '../assets/trump_face.svg';

export const TrumpFace = ({ direction = 'right', ...props }) => (
  <Image
    src={TrumpFaceImage}
    {...props}
    transform={`scaleX(${direction === 'right' ? 1 : -1})`}
  />
);
export const BidenFace = ({ direction = 'left', ...props }) => (
  <Image
    src={BidenFaceImage}
    {...props}
    transform={`scaleX(${direction === 'left' ? 1 : -1})`}
  />
);
